export const navItems = [
  {
    name: 'dashboard',
    label: 'Dashboard',
    path: '/',
  },
  {
    name: 'treatments',
    label: 'Atendimentos',
    path: '/treatments',
  },
  {
    name: 'patients',
    label: 'Pacientes',
    path: '/patients',
  },
  {
    name: 'finances',
    label: 'Financeiro',
    path: '/finances',
  },
];

export const userMenuItems = [
  {
    label: 'Meus horários',
    to: '/my-schedules',
  },
  {
    label: 'Meus dados',
    to: '/my-data',
  },
  {
    label: 'Alterar senha',
    to: '/change-password',
  },
  {
    label: 'Trocar conta',
    to: '/accountSwitch',
  },
  {
    label: 'Manual',
    to: '/manual',
  },
];
